import { render } from "./QOrdersPreloader.vue?vue&type=template&id=09660ba4&scoped=true"
const script = {}

import "./QOrdersPreloader.vue?vue&type=style&index=0&id=09660ba4&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09660ba4"]])

export default __exports__